'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_EditGroupSitePage(code, name) {
  this.Cr = null;
  this.Cs = null;
  this.Cr = code;
  this.Cs = name;
}
export { $c_Lpresto_EditGroupSitePage as $c_Lpresto_EditGroupSitePage };
$p = $c_Lpresto_EditGroupSitePage.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_EditGroupSitePage;
/** @constructor */
function $h_Lpresto_EditGroupSitePage() {
}
export { $h_Lpresto_EditGroupSitePage as $h_Lpresto_EditGroupSitePage };
$h_Lpresto_EditGroupSitePage.prototype = $p;
$p.dw = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$();
});
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lpresto_EditGroupSitePage) && ((this.Cr === x$0.Cr) && (this.Cs === x$0.Cs))));
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 2;
});
$p.s = (function() {
  return "EditGroupSitePage";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.Cr;
  }
  if ((n === 1)) {
    return this.Cs;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_EditGroupSitePage(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.i8)));
}
export { $isArrayOf_Lpresto_EditGroupSitePage as $isArrayOf_Lpresto_EditGroupSitePage };
var $d_Lpresto_EditGroupSitePage = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_EditGroupSitePage, "presto.EditGroupSitePage", ({
  i8: 1,
  a2: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_EditGroupSitePage as $d_Lpresto_EditGroupSitePage };
//# sourceMappingURL=presto.-Edit-Group-Site-Page.js.map
